/** @typedef {import('../../../shared/HomeownerService/Homeowner').HomeownerTeamMember} Member */

import AgentCardCta from './AgentCardCta';
import AgentCardOccupation from './AgentCardOccupation';
import ProfileImage from '../../../../shared/ProfileImage';
import React from 'react';

/**
 * @param {{member: Member}} props
 * @returns {JSX.Element}
 */
function AgentCardTeam(props) {
	const member = props.member;

	return (
		<section className="flex flex-col gap-3 pb-5">
			<hr
				className={`bg-black border-0 rounded-lg opacity-50 h-1 w-3/4`}
			/>

			<section className="flex justify-between">
				<div className="flex flex-col gap-2">
					<h2 className="font-bold text-ms-3">{member.name}</h2>

					<AgentCardOccupation occupation={member.occupation} />

					<h3 className="font-bold text-ms-0">{member.groupName}</h3>
				</div>

				<ProfileImage
					altText={`${member.name}'s headshot`}
					className="avatar avatar-lg border-theme-dark mr-3"
					headshotUrl={member.headshotUrl ?? undefined}
				/>
			</section>

			<AgentCardCta email={member.email} phone={member.phoneNumber} />
		</section>
	);
}

export default React.memo(AgentCardTeam);
